"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SoundPack = exports.SOUND_UNLOCKED = exports.SOUND_TOGGLE_DEBUG = exports.SOUND_STOP = exports.SOUND_RAISE = exports.SOUND_PLAY_RATE = exports.SOUND_PLAY_FROM_SPRITE = exports.SOUND_PLAY = exports.SOUND_LOOP = exports.SOUND_FADE = exports.SOUND_CREATE_SPRITE = exports.SOUND_CREATE = exports.GameSounds = exports.BlitzSounds = void 0;
var SOUND_PLAY = exports.SOUND_PLAY = "SOUND_PLAY";
var SOUND_PLAY_FROM_SPRITE = exports.SOUND_PLAY_FROM_SPRITE = "SOUND_PLAY_FROM_SPRITE";
var SOUND_CREATE = exports.SOUND_CREATE = "SOUND_CREATE";
var SOUND_CREATE_SPRITE = exports.SOUND_CREATE_SPRITE = "SOUND_CREATE_SPRITE";
var SOUND_STOP = exports.SOUND_STOP = "SOUND_STOP";
var SOUND_FADE = exports.SOUND_FADE = "SOUND_FADE";
var SOUND_RAISE = exports.SOUND_RAISE = "SOUND_RAISE";
var SOUND_PLAY_RATE = exports.SOUND_PLAY_RATE = "SOUND_PLAY_RATE";
var SOUND_LOOP = exports.SOUND_LOOP = "SOUND_LOOP_PLAY_RATE";
var SOUND_UNLOCKED = exports.SOUND_UNLOCKED = "SOUND_UNLOCKED";
var SOUND_TOGGLE_DEBUG = exports.SOUND_TOGGLE_DEBUG = "SOUND_TOGGLE_DEBUG";
var SoundPack = exports.SoundPack = /*#__PURE__*/function (SoundPack) {
  SoundPack["Game"] = "game";
  SoundPack["Menu"] = "menu";
  SoundPack["Shared"] = "shared";
  SoundPack["BigWin"] = "bigWin";
  SoundPack["Voice"] = "voice";
  SoundPack["UINOTUSED"] = "uiNotUsed";
  SoundPack["Voice2"] = "voice2";
  SoundPack["Voice3"] = "voice3";
  SoundPack["Voice4"] = "voice4";
  SoundPack["Voice5"] = "voice5";
  SoundPack["Voice6"] = "voice6";
  SoundPack["Music"] = "music";
  return SoundPack;
}({});
/**
 * Dont use, will be removed.
 * @deprecated
 */
var GameSounds = exports.GameSounds = /*#__PURE__*/function (GameSounds) {
  GameSounds["BgStem1"] = "bgStem1";
  GameSounds["ReelStart"] = "reelStart";
  GameSounds["ReelStop"] = "reelStop";
  GameSounds["ReelSpin"] = "reelSpin";
  GameSounds["Scatter1"] = "scatter1";
  GameSounds["Scatter2"] = "scatter2";
  GameSounds["Scatter3"] = "scatter3";
  return GameSounds;
}({});
var BlitzSounds = exports.BlitzSounds = /*#__PURE__*/function (BlitzSounds) {
  BlitzSounds["Start"] = "start";
  BlitzSounds["NormalLoop"] = "normalLoop";
  BlitzSounds["Intro"] = "intro";
  BlitzSounds["SpinsEnd"] = "spinsEnd";
  BlitzSounds["End"] = "end";
  BlitzSounds["Bonus"] = "bonus";
  BlitzSounds["WinExplosion"] = "winExplosion";
  BlitzSounds["WinSpark"] = "winSpark";
  BlitzSounds["PachiSingle"] = "pachiSingle";
  BlitzSounds["PachiTripple"] = "pachiTripple";
  return BlitzSounds;
}({});
//# sourceMappingURL=types.js.map